(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .controller('NavigationController', NavigationController);

    function NavigationController($state, Auth, Principal, ProfileService, LoginService, $rootScope, $localStorage, StoreService, $window, systemConstants) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.settingsAccount = null;
        vm.hubId = $localStorage.defaultStore.hubId;
        vm.isHubShowkase = false;
        vm.redirectUrl = undefined;

        vm.isImmoContext = $localStorage.defaultStore.immoContext;

        setTimeout(function () {
            vm.storeCategory = $localStorage.defaultStore.category;
        }, 1000);

        if (window.location.host.includes('showkase')) {
            vm.isHubShowkase = true;
        }

        Principal.identity().then(function (account) {
            if (account) {
                vm.settingsAccount = angular.copy(account);
                loadStore();
                vm.userProfile = vm.settingsAccount.userProfiles[0];
                vm.isAmbassador = vm.userProfile.profileId === 7;
				vm.isMoipPlanStarter = account.isMoipPlanStarter;
				vm.isMoipPlanFree = 	account.isMoipPlanFree;
            }
        });

        vm.disableOverflow = function () {
            event.stopPropagation();
        }



        vm.redirectTo = function (page, sellerId) {
            var params = {
                sellerId: sellerId,
                page: "1",
                sort: "id,asc",
                type: undefined
            }

            $state.go(page, params);
        }

        vm.enableOverflow = function () {}

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('main-login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        $rootScope.$on('settings-updated', function () {
            Principal.identity().then(function (account) {
                if (account) {
                    vm.settingsAccount = angular.copy(account);
                    vm.userProfile = vm.settingsAccount.userProfiles[0];
                    vm.isAmbassador = vm.userProfile.profileId === 7;
                    loadStore();
                }
            });
        });

        function loadStore() {
            StoreService.getStore($localStorage.defaultStore.storeId, vm.settingsAccount.id).then(function(response) {
                $localStorage.defaultStore.storeType = response.data.storeType;
                $localStorage.defaultStore.defaultFilter = response.data.defaultFilter;
                vm.redirectUrl = response.data.redirectURL;
                vm.store = response.data;
                vm.secondaryProfileInfo = setSecondaryInfo(response.data);
                setStoreLogo();
            });
        }

        vm.getShowcaseURL = function() {
            if (vm.redirectUrl) {
                $window.open($window.location.protocol + '//' + vm.redirectUrl, '_blank');
            } else if (!$localStorage.defaultStore.storeNickname) {
                StoreService.getStore($localStorage.defaultStore.storeId, vm.settingsAccount ? vm.settingsAccount.id : null).then(function(response) {
                    $localStorage.defaultStore.storeNickname = response.data.nickname;
                    $localStorage.defaultStore.storeType = response.data.storeType;
                    vm.store = response.data;
                    vm.secondaryProfileInfo = setSecondaryInfo(response.data);
                    setStoreLogo();
                    $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType), '_blank');
                });
            } else {
                $window.open($window.location.protocol + '//' + $localStorage.defaultStore.storeNickname + '.' + getDomainNameSufix($window, vm.store.storeType), '_blank');
            }

        }

        function setStoreLogo() {
            vm.store.logo = vm.store.logo ? vm.store.logo.replace('%25s', 'logo') : '/content/images/profile_small.png';
            $localStorage.defaultStore.performanceDashboard = vm.store.performanceDashboard;
            $localStorage.defaultStore.chatPerformanceDashboard = vm.store.chatPerformanceDashboard;
            $localStorage.defaultStore.sellerPerformanceDashboard = vm.store.sellerPerformanceDashboard;
            if (vm.settingsAccount && vm.settingsAccount.id) {
                $localStorage.defaultStore.sellerIndividualPerformanceDashboard = vm.store.sellerIndividualPerformanceDashboard;
            }
            $localStorage.defaultStore.abandonedCartDashboard = vm.store.abandonedCartDashboard;
            $localStorage.defaultStore.crmDashboard = vm.store.crmDashboard;
        }

        function setSecondaryInfo(store) {
            return vm.isImmoContext
                ? store.email
                : store.cnpj
                    ? formatCNPJ(store.cnpj)
                    : store.email;
        }

        if (vm.hubId === 33) {
            var s = document.createElement('script');
            s.defer = true;
            s.src = 'https://roadmap.immo360.com.br/widgets_sdk';
            document.head.appendChild(s);
        } else {
            var s = document.createElement('script');
            s.defer = true;
            s.src = 'https://roadmap.showkase.com.br/widgets_sdk';
            document.head.appendChild(s);
        }

    }
})();
